export default __webpack_public_path__ + "static/media/your_target.9895eb92.png";